(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4968],{

/***/ 53090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(43846),
    toInteger = __webpack_require__(20426);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),

/***/ 74088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(5710),
    func = convert('dropRight', __webpack_require__(53090));

func.placeholder = __webpack_require__(84859);
module.exports = func;


/***/ }),

/***/ 3104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pK": function() { return /* reexport */ MultiGovernmentSelect; },
  "Bm": function() { return /* reexport */ MultiVendorSelect; },
  "iF": function() { return /* reexport */ ProductSelect; },
  "Ph": function() { return /* reexport */ Select; },
  "Ts": function() { return /* reexport */ StoryProductSelect; }
});

// UNUSED EXPORTS: CategorySelect, EmailTagsInputField, GovernmentSelect, MultiProductSelect

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(96404);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(99951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(84443);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(48465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(20597);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/downshift@6.1.7_react@17.0.2/node_modules/downshift/dist/downshift.esm.js
var downshift_esm = __webpack_require__(27242);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/defaultStateReducer.js



function defaultStateReducer(state, changes) {
    switch(changes.type){
        case downshift_esm/* default.stateChangeTypes.controlledPropUpdatedSelectedItem */.ZP.stateChangeTypes.controlledPropUpdatedSelectedItem:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changes), {
                    inputValue: "",
                    isOpen: true,
                    highlightedIndex: 0
                });
            }
        case downshift_esm/* default.stateChangeTypes.changeInput */.ZP.stateChangeTypes.changeInput:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changes), {
                    highlightedIndex: 0
                });
            }
        case downshift_esm/* default.stateChangeTypes.keyDownArrowDown */.ZP.stateChangeTypes.keyDownArrowDown:
            {
                if (changes.highlightedIndex === null) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changes), {
                        highlightedIndex: 0
                    });
                }
                return changes;
            }
        default:
            {
                return changes;
            }
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/dropRight.js
var dropRight = __webpack_require__(74088);
var dropRight_default = /*#__PURE__*/__webpack_require__.n(dropRight);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/get.js
var get = __webpack_require__(48182);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__(40768);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+css-layers@0.3.0/node_modules/@govlaunch/css-layers/index.js
var css_layers = __webpack_require__(34557);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsContainer.js







function TagsContainer(_param) {
    var children = _param.children, css = _param.css, innerRef = _param.innerRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)({
            position: "relative",
            minWidth: 350,
            zIndex: css_layers/* SELECT */.XD
        }, css),
        ref: innerRef
    }, props), {
        children: children
    }));
};
TagsContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    css: (prop_types_default()).object,
    innerRef: (prop_types_default()).func
};
TagsContainer.defaultProps = {
    css: {},
    innerRef: null
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/Tags.js






function Tags(_param) {
    var children = _param.children, css = _param.css, innerRef = _param.innerRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: innerRef,
        css: (0,_object_spread/* default */.Z)({
            position: "relative",
            display: "flex",
            alignItems: "center",
            minHeight: 40,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            borderRadius: 4,
            border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
            backgroundColor: "#ffffff",
            paddingBottom: 5,
            paddingLeft: 5,
            paddingRight: 5
        }, applyDisabledStyles(props), applyAttentionStyles(props), applyValidationStateStyles(props), css),
        children: children
    });
};
Tags.propTypes = {
    children: (prop_types_default()).node.isRequired,
    css: (prop_types_default()).object,
    innerRef: (prop_types_default()).func
};
Tags.defaultProps = {
    css: {},
    innerRef: null
};
/**
 * @param  {Boolean} disabled
 * @return {Object}
 */ function applyDisabledStyles(param) {
    var disabled = param.disabled;
    if (disabled) {
        return {
            backgroundColor: palette/* lightestGray */.v2,
            border: "1px solid transparent"
        };
    }
    return null;
}
/**
 * @param  {Boolean} isOpen
 * @return {Object}
 */ function applyAttentionStyles(param) {
    var isOpen = param.isOpen;
    if (isOpen) {
        return {
            border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        };
    }
    return null;
}
/**
 * @param  {String} validationState
 * @return {Object}
 */ function applyValidationStateStyles(param) {
    var validationState = param.validationState;
    if (validationState === "error") {
        return {
            borderColor: palette/* red */.Q6
        };
    }
    if (validationState === "success") {
        return {
            borderColor: palette/* greenSuccess */.CU
        };
    }
    return null;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/noop.js
var noop = __webpack_require__(98483);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/omit.js
var omit = __webpack_require__(53104);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsPack.js







function TagsPack(_param) {
    var children = _param.children, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)({
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 5,
            paddingRight: 5,
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            flex: "1 1 auto",
            flexWrap: "wrap"
        }, css)
    }, omit_default()("validationState", props)), {
        children: children
    }));
};
TagsPack.propTypes = {
    children: (prop_types_default()).node.isRequired,
    css: (prop_types_default()).object
};
TagsPack.defaultProps = {
    css: {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/icons/Close.js






function Close(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: color || "currentColor",
            fillRule: "nonzero",
            stroke: color || "currentColor",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1.25 13a.246.246 0 0 0 .177-.076l5.5-5.74a.27.27 0 0 0 0-.368l-5.5-5.74a.243.243 0 0 0-.354 0 .27.27 0 0 0 0 .37L6.396 7l-5.323 5.554a.27.27 0 0 0 0 .37.242.242 0 0 0 .177.076z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M12.75 1a.246.246 0 0 0-.177.076l-5.5 5.74a.27.27 0 0 0 0 .368l5.5 5.74a.243.243 0 0 0 .354 0 .27.27 0 0 0 0-.37L7.604 7l5.323-5.554a.27.27 0 0 0 0-.37A.242.242 0 0 0 12.75 1z"
                })
            ]
        })
    }));
};
Close.propTypes = {
    color: (prop_types_default()).string
};
Close.defaultProps = {
    color: null
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/Tag.js










/**
 * @param  {Boolean} active
 * @param  {Boolean} selected
 * @return {?Object}
 */ function applyActiveStyles(param) {
    var active = param.active, selected = param.selected, highlighted = param.highlighted;
    if (highlighted) {
        return {
            borderColor: palette/* orange */.$y
        };
    }
    if (active || selected) {
        return {
            color: palette/* text */.fL,
            borderColor: palette/* primary */.T$
        };
    }
    return null;
}
/**
 * @return {Object}
 * @return {Object}
 */ function Tag_applyDisabledStyles(props) {
    if (props.disabled) {
        return {
            cursor: "default",
            pointerEvents: "none",
            backgroundColor: palette/* lightestGray */.v2,
            borderColor: palette/* lightGray */.l2,
            color: palette/* sealBlue */.N9
        };
    }
    return null;
}
/**
 * @return {Object}
 * @return {Object}
 */ function Tag_applyValidationStateStyles(props) {
    if (props.validationState === "error") {
        return {
            color: palette/* red */.Q6,
            borderColor: palette/* red */.Q6
        };
    }
    return null;
}
function Tag(_param) {
    var children = _param.children, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)({
            maxWidth: 200,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
            border: "solid 1px ".concat(palette/* lightGray */.l2),
            borderRadius: 4,
            color: palette/* darkGray */.O5,
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 2.33,
            height: 25,
            marginRight: 10,
            marginTop: 5,
            padding: 7,
            backgroundColor: "#ffffff"
        }, applyActiveStyles(props), Tag_applyDisabledStyles(props), Tag_applyValidationStateStyles(props), css)
    }, omit_default()([
        "active",
        "isActive",
        "validationState"
    ], props)), {
        children: children
    }));
};
var sanitizeTitle = function(children) {
    return Array.isArray(children) ? children.filter(function(child) {
        return typeof child === "string";
    }).join("") : children;
};
function TagText(_param) {
    var children = _param.children, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: sanitizeTitle(children),
        css: (0,_object_spread/* default */.Z)({
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            position: "relative"
        }, css)
    }, props), {
        children: children
    }));
}
TagText.propTypes = {
    children: (prop_types_default()).any.isRequired,
    css: (prop_types_default()).object
};
TagText.defaultProps = {
    css: {}
};
function TagClose(_param) {
    var css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": "remove item",
        css: (0,_object_spread/* default */.Z)({
            color: palette/* primary */.T$
        }, css)
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close, {
            width: 7,
            height: 7
        })
    }));
}
TagClose.propTypes = {
    css: (prop_types_default()).object
};
TagClose.defaultProps = {
    css: {}
};
Tag.propTypes = {
    children: (prop_types_default()).any.isRequired,
    onClose: (prop_types_default()).func,
    active: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).string
    ]),
    selected: (prop_types_default()).bool,
    validationState: prop_types_default().oneOf([
        "error"
    ]),
    css: (prop_types_default()).object
};
Tag.defaultProps = {
    onClose: (noop_default()),
    active: false,
    selected: false,
    validationState: null,
    css: null
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/RawButton.js





function RawButton(_param) {
    var innerRef = _param.innerRef, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "innerRef",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread/* default */.Z)({
        type: "button",
        ref: innerRef,
        css: (0,_object_spread/* default */.Z)({
            marginLeft: 15,
            padding: 0,
            background: "none",
            border: 0,
            display: "flex",
            outline: 0,
            cursor: "pointer"
        }, css)
    }, props));
};
RawButton.propTypes = {
    innerRef: (prop_types_default()).func,
    css: (prop_types_default()).object
};
RawButton.defaultProps = {
    innerRef: null,
    css: {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/GovernmentTag.js











function GovernmentTag(_param) {
    var government = _param.government, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "government",
        "onClose"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose,
        css: {
            maxWidth: 320,
            height: 32,
            paddingLeft: 15,
            paddingRight: 15
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginRight: 10,
                    display: "inline-flex"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    name: government.name || government.city.name,
                    image: government.logo,
                    size: 25
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                css: {
                    color: palette/* text */.fL,
                    fontWeight: 500,
                    fontSize: 12,
                    textTransform: "uppercase"
                },
                children: government.name || "".concat(government.city.name, ", ").concat(government.city.state)
            }),
            onClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RawButton, {
                onClick: onClose,
                tabIndex: 0,
                css: {
                    marginLeft: 15
                },
                type: "button",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagClose, {})
            })
        ]
    }));
};
GovernmentTag.propTypes = {
    government: (prop_types_default()).object.isRequired,
    onClose: (prop_types_default()).func
};
GovernmentTag.defaultProps = {
    onClose: (noop_default())
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-input-autosize@3.0.0_react@17.0.2/node_modules/react-input-autosize/lib/AutosizeInput.js
var AutosizeInput = __webpack_require__(24519);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(81031);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsAutosizeInput.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            &::placeholder {\n              color: ",
        ";\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function TagsAutosizeInput(_param) {
    var setInputStyle = _param.inputStyle, setContainerStyle = _param.containerStyle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputStyle",
        "containerStyle"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* ClassNames */.ms, {
        children: function(param) {
            var css = param.css;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutosizeInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                spellCheck: false,
                autoComplete: "off"
            }, props), {
                style: (0,_object_spread/* default */.Z)({}, containerStyle, setContainerStyle),
                inputClassName: css(_templateObject(), palette/* sealBlue */.N9),
                inputStyle: (0,_object_spread/* default */.Z)({}, inputStyle, setInputStyle)
            }));
        }
    });
};
TagsAutosizeInput.propTypes = {
    inputStyle: (prop_types_default()).object,
    containerStyle: (prop_types_default()).object
};
TagsAutosizeInput.defaultProps = {
    inputStyle: null,
    containerStyle: null
};
var containerStyle = {
    display: "inline-flex",
    flex: 1,
    minWidth: 50,
    marginTop: 5
};
var inputStyle = {
    width: "100%",
    height: "100%",
    minHeight: 25,
    boxSizing: "border-box",
    color: palette/* text */.fL,
    fontSize: 14,
    fontWeight: 500,
    boxShadow: "none",
    margin: 0,
    padding: "0 0 0 5px",
    outline: 0,
    border: "none",
    backgroundColor: "transparent"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsMenu.js







function TagsMenu(_param) {
    var children = _param.children, validationState = _param.validationState, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "validationState"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)({}, TagsMenu_containerStyle, validationState === "error" && errorContainerStyle)
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,_object_spread/* default */.Z)({}, arrowStyle, validationState === "error" && errorArrowStyle)
            }),
            children
        ]
    }));
};
TagsMenu.propTypes = {
    validationState: (prop_types_default()).string,
    children: (prop_types_default()).any.isRequired
};
TagsMenu.defaultProps = {
    validationState: null
};
var errorContainerStyle = {
    borderLeft: "solid 1px ".concat(palette/* red */.Q6),
    borderRight: "solid 1px ".concat(palette/* red */.Q6),
    borderBottom: "solid 1px ".concat(palette/* red */.Q6),
    backgroundColor: palette/* lightRed */.r6,
    color: palette/* red */.Q6
};
var TagsMenu_containerStyle = {
    backgroundColor: palette/* lightestBlue */.I,
    fontSize: 12,
    fontWeight: 500,
    paddingLeft: 10,
    paddingBottom: 10,
    color: palette/* primary */.T$,
    borderLeft: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
    borderRight: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
    borderBottom: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    position: "absolute",
    width: "100%",
    boxSizing: "border-box"
};
var errorArrowStyle = {
    borderColor: "transparent transparent ".concat(palette/* lightRed */.r6, " transparent")
};
var arrowStyle = {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "0 7px 8px 7px",
    borderColor: "transparent transparent ".concat(palette/* lightestBlue */.I, " transparent"),
    position: "absolute",
    top: 0,
    left: 0,
    marginTop: -6,
    marginLeft: 20
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/Clear.js







function Clear(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        "aria-label": "Clear",
        title: "Clear",
        tabIndex: 0,
        css: {
            ":focus": {
                color: palette/* text */.fL
            },
            marginLeft: "auto",
            cursor: "pointer",
            background: "none",
            border: 0,
            padding: 2,
            outline: 0,
            marginTop: 5,
            marginRight: 15,
            color: palette/* sealBlue */.N9
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close, {
            width: 10,
            height: 10
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsMenuHint.js






function TagsMenuHint(_param) {
    var children = _param.children, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)({
            padding: 7
        }, css)
    }, props), {
        children: children
    }));
};
TagsMenuHint.propTypes = {
    children: (prop_types_default()).any,
    css: (prop_types_default()).object
};
TagsMenuHint.defaultProps = {
    children: null,
    css: {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/SharedRef.js







var SharedRef = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SharedRef, Component);
    var _super = (0,_create_super/* default */.Z)(SharedRef);
    function SharedRef() {
        (0,_class_call_check/* default */.Z)(this, SharedRef);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "setInnerRef", function(node) {
            _this.currentRef = node;
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "render", function() {
            return _this.props.children({
                current: function() {
                    return _this.currentRef;
                },
                innerRef: _this.setInnerRef
            });
        });
        return _this;
    }
    return SharedRef;
}(react.Component);
(0,_define_property/* default */.Z)(SharedRef, "propTypes", {
    children: (prop_types_default()).func.isRequired
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/MultiGovernmentSelect.js




























var MultiGovernmentSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MultiGovernmentSelect, Component);
    var _super = (0,_create_super/* default */.Z)(MultiGovernmentSelect);
    function MultiGovernmentSelect() {
        (0,_class_call_check/* default */.Z)(this, MultiGovernmentSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyDown", function(e) {
            var _props = _this.props, governments = _props.governments, onChange = _props.onChange, inputValue = _props.inputValue;
            if (e.key === "Backspace" && inputValue.length === 0 && governments.length > 0) {
                onChange(dropRight_default()(1, governments));
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleRemoveGovernment", function(e, government) {
            e.persist();
            var _props = _this.props, governments = _props.governments, onChange = _props.onChange;
            onChange(governments.filter(function(maybeProduct) {
                return maybeProduct !== government;
            }));
            var focusables = Array.from(_this.tagsRef.querySelectorAll('[tabindex="0"]'));
            var position = focusables.findIndex(function(focusable) {
                return focusable === e.target;
            });
            var element = focusables[position > 0 ? position - 1 : 1];
            if (governments.length > 1 && element) {
                element.focus();
            } else if (governments.length === 1 && element) {
                _this.inputRef.focus();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClearKeyDown", function(e) {
            if (e.key === "Enter") {
                var onChange = _this.props.onChange;
                onChange([]);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(newValue) {
            var _props = _this.props, governments = _props.governments, onChange = _props.onChange, onInputValueChange = _props.onInputValueChange;
            onChange(governments.concat(newValue));
            onInputValueChange("");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(MultiGovernmentSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, defaultValue = _props.defaultValue, governments = _props.governments, selectableGovernments = _props.selectableGovernments, onChange = _props.onChange, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, itemToString = _props.itemToString, disabled = _props.disabled, onFocus = _props.onFocus, onBlur = _props.onBlur, placeholder = _props.placeholder, borderColor = _props.borderColor, error = _props.error, props = (0,_object_without_properties/* default */.Z)(_props, [
                    "defaultValue",
                    "governments",
                    "selectableGovernments",
                    "onChange",
                    "inputValue",
                    "onInputValueChange",
                    "itemToString",
                    "disabled",
                    "onFocus",
                    "onBlur",
                    "placeholder",
                    "borderColor",
                    "error"
                ]);
                var validationState = error ? "error" : null;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    itemToString: itemToString,
                    defaultSelectedItem: defaultValue,
                    onChange: this.handleChange,
                    inputValue: inputValue,
                    selectedItem: governments,
                    selectedItemChanged: function(a, b) {
                        if (a && b) {
                            return a.length !== b.length;
                        }
                        return a !== b;
                    },
                    stateReducer: defaultStateReducer,
                    children: function(param) {
                        var getInputProps = param.getInputProps, getRootProps = param.getRootProps, getItemProps = param.getItemProps, selectedItems = param.selectedItem, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, inputValue = param.inputValue;
                        var governments = selectableGovernments.filter(function(param) {
                            var objectID = param.objectID;
                            return !selectedItems.find(function(param) {
                                var governmentId = param.objectID;
                                return governmentId === objectID;
                            });
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({
                            refKey: "innerRef"
                        }), props), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SharedRef, {
                                    children: function(param) {
                                        var current = param.current, innerRef = param.innerRef;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tags, {
                                            isOpen: isOpen || validationState === "error",
                                            validationState: validationState,
                                            disabled: disabled,
                                            innerRef: function(node) {
                                                _this.tagsRef = node;
                                            },
                                            css: borderColor ? {
                                                borderColor: borderColor
                                            } : null,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsPack, {
                                                    validationState: validationState,
                                                    children: [
                                                        uniqBy_default()(function(government) {
                                                            return government._id || government.objectID;
                                                        }, selectedItems).map(function(government) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentTag, {
                                                                government: government,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveGovernment(e, government);
                                                                },
                                                                disabled: disabled
                                                            }, government._id || government.objectID);
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsAutosizeInput, (0,_object_spread/* default */.Z)({
                                                            disabled: disabled,
                                                            inputRef: function(node) {
                                                                innerRef(node);
                                                                _this.inputRef = node;
                                                            },
                                                            value: inputValue,
                                                            onFocus: onFocus,
                                                            onBlur: onBlur,
                                                            tabIndex: 0
                                                        }, getInputProps({
                                                            placeholder: selectedItems.length === 0 ? placeholder : null,
                                                            "aria-label": "Type government names",
                                                            onKeyDown: _this.handleKeyDown,
                                                            onChange: function(e) {
                                                                onInputValueChange(e.target.value);
                                                            }
                                                        })))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                                    onKeyDown: function(e) {
                                                        _this.handleClearKeyDown(e);
                                                        current().focus();
                                                    },
                                                    onClick: function() {
                                                        onChange([]);
                                                        current().focus();
                                                    }
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (isOpen || validationState === "error") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsMenu, {
                                    validationState: validationState,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsPack, {
                                            validationState: validationState,
                                            children: governments.map(function(government, index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                    index: index,
                                                    item: government,
                                                    active: index === highlightedIndex
                                                })), {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagText, {
                                                        children: [
                                                            government.city.name,
                                                            ", ",
                                                            government.city.state
                                                        ]
                                                    })
                                                }), government.objectID);
                                            })
                                        }),
                                        error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: error
                                        }),
                                        governments.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: "No governments found"
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                });
            }
        }
    ]);
    return MultiGovernmentSelect;
}(react.Component);
(0,_define_property/* default */.Z)(MultiGovernmentSelect, "propTypes", {
    defaultValue: (prop_types_default()).array,
    governments: (prop_types_default()).array.isRequired,
    selectableGovernments: (prop_types_default()).array.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    inputValue: (prop_types_default()).string.isRequired,
    onInputValueChange: (prop_types_default()).func.isRequired,
    itemToString: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    error: (prop_types_default()).string,
    css: (prop_types_default()).object,
    placeholder: (prop_types_default()).string,
    borderColor: (prop_types_default()).string
});
(0,_define_property/* default */.Z)(MultiGovernmentSelect, "defaultProps", {
    defaultValue: [],
    itemToString: get_default()("objectID"),
    disabled: false,
    onFocus: (noop_default()),
    onBlur: (noop_default()),
    error: null,
    css: {},
    placeholder: "Type government names...",
    borderColor: null
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/VendorTag.js











function VendorTag(_param) {
    var vendor = _param.vendor, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "vendor",
        "onClose"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose,
        css: {
            maxWidth: 320,
            height: 32,
            paddingLeft: 15,
            paddingRight: 15
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginRight: 10,
                    display: "inline-flex"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    name: vendor.name || vendor.city.name,
                    image: vendor.logo,
                    size: 25
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                css: {
                    color: palette/* text */.fL,
                    fontWeight: 500,
                    fontSize: 12,
                    textTransform: "uppercase"
                },
                children: vendor.name
            }),
            onClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RawButton, {
                onClick: onClose,
                tabIndex: 0,
                css: {
                    marginLeft: 15
                },
                type: "button",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagClose, {})
            })
        ]
    }));
};
VendorTag.propTypes = {
    vendor: (prop_types_default()).object.isRequired,
    onClose: (prop_types_default()).func
};
VendorTag.defaultProps = {
    onClose: (noop_default())
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/MultiVendorSelect.js




























var MultiVendorSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MultiVendorSelect, Component);
    var _super = (0,_create_super/* default */.Z)(MultiVendorSelect);
    function MultiVendorSelect() {
        (0,_class_call_check/* default */.Z)(this, MultiVendorSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyDown", function(e) {
            var _props = _this.props, vendors = _props.vendors, onChange = _props.onChange, inputValue = _props.inputValue;
            if (e.key === "Backspace" && inputValue.length === 0 && vendors.length > 0) {
                onChange(dropRight_default()(1, vendors));
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleRemoveVendor", function(e, vendor) {
            e.persist();
            var _props = _this.props, vendors = _props.vendors, onChange = _props.onChange;
            onChange(vendors.filter(function(maybeProduct) {
                return maybeProduct !== vendor;
            }));
            var focusables = Array.from(_this.tagsRef.querySelectorAll('[tabindex="0"]'));
            var position = focusables.findIndex(function(focusable) {
                return focusable === e.target;
            });
            var element = focusables[position > 0 ? position - 1 : 1];
            if (vendors.length > 1 && element) {
                element.focus();
            } else if (vendors.length === 1 && element) {
                _this.inputRef.focus();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClearKeyDown", function(e) {
            if (e.key === "Enter") {
                var onChange = _this.props.onChange;
                onChange([]);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(newValue) {
            var _props = _this.props, vendors = _props.vendors, onChange = _props.onChange, onInputValueChange = _props.onInputValueChange;
            onChange(vendors.concat(newValue));
            onInputValueChange("");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(MultiVendorSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, defaultValue = _props.defaultValue, vendors = _props.vendors, selectableVendors = _props.selectableVendors, onChange = _props.onChange, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, itemToString = _props.itemToString, disabled = _props.disabled, onFocus = _props.onFocus, onBlur = _props.onBlur, placeholder = _props.placeholder, borderColor = _props.borderColor, error = _props.error, props = (0,_object_without_properties/* default */.Z)(_props, [
                    "defaultValue",
                    "vendors",
                    "selectableVendors",
                    "onChange",
                    "inputValue",
                    "onInputValueChange",
                    "itemToString",
                    "disabled",
                    "onFocus",
                    "onBlur",
                    "placeholder",
                    "borderColor",
                    "error"
                ]);
                var validationState = error ? "error" : null;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    itemToString: itemToString,
                    defaultSelectedItem: defaultValue,
                    onChange: this.handleChange,
                    inputValue: inputValue,
                    selectedItem: vendors,
                    selectedItemChanged: function(a, b) {
                        if (a && b) {
                            return a.length !== b.length;
                        }
                        return a !== b;
                    },
                    stateReducer: defaultStateReducer,
                    children: function(param) {
                        var getInputProps = param.getInputProps, getRootProps = param.getRootProps, getItemProps = param.getItemProps, selectedItems = param.selectedItem, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, inputValue = param.inputValue;
                        var vendors = selectableVendors.filter(function(param) {
                            var objectID = param.objectID;
                            return !selectedItems.find(function(param) {
                                var vendorId = param.objectID;
                                return vendorId === objectID;
                            });
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({
                            refKey: "innerRef"
                        }), props), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SharedRef, {
                                    children: function(param) {
                                        var current = param.current, innerRef = param.innerRef;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tags, {
                                            isOpen: isOpen || validationState === "error",
                                            validationState: validationState,
                                            disabled: disabled,
                                            innerRef: function(node) {
                                                _this.tagsRef = node;
                                            },
                                            css: borderColor ? {
                                                borderColor: borderColor
                                            } : null,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsPack, {
                                                    validationState: validationState,
                                                    children: [
                                                        uniqBy_default()(function(vendor) {
                                                            return vendor._id || vendor.objectID;
                                                        }, selectedItems).map(function(vendor) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorTag, {
                                                                vendor: vendor,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveVendor(e, vendor);
                                                                },
                                                                disabled: disabled
                                                            }, vendor._id || vendor.objectID);
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsAutosizeInput, (0,_object_spread/* default */.Z)({
                                                            disabled: disabled,
                                                            inputRef: function(node) {
                                                                innerRef(node);
                                                                _this.inputRef = node;
                                                            },
                                                            value: inputValue,
                                                            onFocus: onFocus,
                                                            onBlur: onBlur,
                                                            tabIndex: 0
                                                        }, getInputProps({
                                                            placeholder: selectedItems.length === 0 ? placeholder : null,
                                                            "aria-label": "Type vendor names",
                                                            onKeyDown: _this.handleKeyDown,
                                                            onChange: function(e) {
                                                                onInputValueChange(e.target.value);
                                                            }
                                                        })))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                                    onKeyDown: function(e) {
                                                        _this.handleClearKeyDown(e);
                                                        current().focus();
                                                    },
                                                    onClick: function() {
                                                        onChange([]);
                                                        current().focus();
                                                    }
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (isOpen || validationState === "error") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsMenu, {
                                    validationState: validationState,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsPack, {
                                            validationState: validationState,
                                            children: vendors.map(function(vendor, index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                    index: index,
                                                    item: vendor,
                                                    active: index === highlightedIndex
                                                })), {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                                                        children: vendor.name
                                                    })
                                                }), vendor.objectID);
                                            })
                                        }),
                                        error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: error
                                        }),
                                        vendors.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: "No vendors found"
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                });
            }
        }
    ]);
    return MultiVendorSelect;
}(react.Component);
(0,_define_property/* default */.Z)(MultiVendorSelect, "propTypes", {
    defaultValue: (prop_types_default()).array,
    vendors: (prop_types_default()).array.isRequired,
    selectableVendors: (prop_types_default()).array.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    inputValue: (prop_types_default()).string.isRequired,
    onInputValueChange: (prop_types_default()).func.isRequired,
    itemToString: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    error: (prop_types_default()).string,
    css: (prop_types_default()).object,
    placeholder: (prop_types_default()).string,
    borderColor: (prop_types_default()).string
});
(0,_define_property/* default */.Z)(MultiVendorSelect, "defaultProps", {
    defaultValue: [],
    itemToString: get_default()("objectID"),
    disabled: false,
    onFocus: (noop_default()),
    onBlur: (noop_default()),
    error: null,
    css: {},
    placeholder: "Type vendor names...",
    borderColor: null
});


// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/icons/Alert.js




var Alert = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 14,
        height: 14,
        viewBox: "0 0 14 14"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7z",
                    fill: "#F1AA4E"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M6.979 8.5a1.508 1.508 0 0 1-.386-1.035c0-1.372 1.72-1.535 1.72-2.337 0-.36-.28-.663-.924-.663-.586 0-1.078.28-1.44.721L5 4.128C5.62 3.395 6.557 3 7.564 3 9.074 3 10 3.756 10 4.837c0 1.698-1.956 1.826-1.956 2.803 0 .186.094.383.223.488L6.979 8.5zM7.54 11a.956.956 0 0 1-.948-.942c0-.511.433-.942.948-.942.515 0 .948.43.948.942a.956.956 0 0 1-.948.942z",
                    fill: "#FFF"
                })
            ]
        })
    }));
};
/* harmony default export */ var icons_Alert = (Alert);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/icons/Link.js




var Link = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 20,
        height: 20,
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                    id: "a",
                    width: "112.6%",
                    height: "134.2%",
                    x: "-6.3%",
                    y: "-14.8%",
                    filterUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feOffset", {
                            dy: 5,
                            in: "SourceAlpha",
                            result: "shadowOffsetOuter1"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                            in: "shadowOffsetOuter1",
                            result: "shadowBlurOuter1",
                            stdDeviation: 10
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feColorMatrix", {
                            in: "shadowBlurOuter1",
                            result: "shadowMatrixOuter1",
                            values: "0 0 0 0 0.729411765 0 0 0 0 0.729411765 0 0 0 0 0.729411765 0 0 0 0.35 0"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("feMerge", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feMergeNode", {
                                    in: "shadowMatrixOuter1"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: 515,
                        height: 182,
                        x: 0.5,
                        y: 10.5,
                        fill: "#FFF",
                        stroke: "currentColor",
                        filter: "url(#a)",
                        rx: 4,
                        transform: "translate(-44 -81)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#FFF",
                        stroke: "#F2F4F8",
                        d: "M-10-12.5A3.5 3.5 0 0 0-13.5-9v37a3.5 3.5 0 0 0 3.5 3.5h448a3.5 3.5 0 0 0 3.5-3.5V-9a3.5 3.5 0 0 0-3.5-3.5H-10z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#A5ADBA",
                        fillRule: "nonzero",
                        d: "M18.901 1.383l-.285-.286a3.755 3.755 0 0 0-5.305 0l-2.205 2.205a3.726 3.726 0 0 0-1.098 2.653c0 .918.34 1.777.94 2.46l-2.52 2.545c-1.471-1.3-3.717-1.26-5.124.146l-2.205 2.206A3.726 3.726 0 0 0 0 15.964a3.73 3.73 0 0 0 1.099 2.654l.285.286A3.739 3.739 0 0 0 4.037 20c.96 0 1.92-.365 2.652-1.096l2.205-2.206a3.726 3.726 0 0 0 .127-5.152l2.513-2.537a3.736 3.736 0 0 0 2.51.98c.96 0 1.921-.364 2.652-1.095l2.205-2.206A3.726 3.726 0 0 0 20 4.035c0-1.003-.39-1.943-1.099-2.652zM9.158 14.046a2.9 2.9 0 0 1-.854 2.063l-2.205 2.206a2.923 2.923 0 0 1-4.126 0l-.286-.286a2.9 2.9 0 0 1-.854-2.064 2.9 2.9 0 0 1 .854-2.063l2.205-2.206a2.909 2.909 0 0 1 2.063-.853c.675 0 1.344.246 1.887.71l-1.88 1.897a.417.417 0 0 0 .592.587l1.88-1.897c.46.53.724 1.194.724 1.906zm9.154-7.948l-2.205 2.206c-1.094 1.095-2.843 1.123-3.987.113l1.866-1.884a.417.417 0 0 0-.592-.586l-1.86 1.877a2.89 2.89 0 0 1 .16-3.932L13.9 1.686a2.909 2.909 0 0 1 2.063-.853c.746 0 1.494.285 2.063.853l.285.286a2.9 2.9 0 0 1 .855 2.064c0 .779-.303 1.511-.854 2.062z"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var icons_Link = (Link);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/DelayedMount.js








var DelayedMount = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DelayedMount, Component);
    var _super = (0,_create_super/* default */.Z)(DelayedMount);
    function DelayedMount() {
        (0,_class_call_check/* default */.Z)(this, DelayedMount);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            shouldMount: false
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(DelayedMount, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                this.interval = setTimeout(function() {
                    return _this.setState({
                        shouldMount: true
                    });
                }, this.props.delay);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // if the component unmounts before `this.props.delay`
                clearTimeout(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var shouldMount = this.state.shouldMount;
                return shouldMount ? children : null;
            }
        }
    ]);
    return DelayedMount;
}(react.Component);
(0,_define_property/* default */.Z)(DelayedMount, "propTypes", {
    delay: (prop_types_default()).number.isRequired,
    children: (prop_types_default()).any.isRequired
});


// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/NewProductTag.js

















function NewProductTag(param) {
    var onChange = param.onChange, product = param.product, onClose = param.onClose, selected = param.selected;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
        children: function(isMobile) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                children: function(param) {
                    var isOpen = param.on, setOpen = param.set, toggle = param.toggle;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                        placement: "bottom",
                        onClickOutside: function() {
                            if (isMobile) {
                                return;
                            }
                            setOpen(false);
                        },
                        isOpen: isOpen,
                        borderColor: palette/* lightestGray */.v2,
                        boxStyle: {
                            boxShadow: "-2px 5px 20px 1px rgba(0, 0, 0, 0.1)"
                        },
                        render: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                                initial: product.url,
                                children: function(param) {
                                    var inputValue = param.value, onInputChange = param.set;
                                    if (isMobile) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* MobileScreen */.vp, {
                                            isOpen: true,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* MobileScreenHeader */.uD, {
                                                    onRequestClose: function() {
                                                        toggle();
                                                    },
                                                    children: "Add this product to Govlaunch!"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* MobileScreenBody */.Ly, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                                            autoFocus: true,
                                                            backgroundColor: "#fff",
                                                            backgroundClip: "padding-box",
                                                            width: "100%",
                                                            borderRadius: 4,
                                                            padding: "0 20px",
                                                            css: {
                                                                "::placeholder": {
                                                                    color: palette/* sealBlue */.N9
                                                                },
                                                                ":focus": {
                                                                    border: "1px solid ".concat(palette/* darkSkyBlue */.Gf),
                                                                    color: palette/* darkGray */.O5,
                                                                    boxShadow: "none"
                                                                },
                                                                ":hover": {
                                                                    boxShadow: "none"
                                                                }
                                                            },
                                                            outline: 0,
                                                            height: 42,
                                                            color: palette/* mediumGray */.rF,
                                                            boxShadow: "none",
                                                            fontWeight: 500,
                                                            value: inputValue || "",
                                                            onChange: function(e) {
                                                                return onInputChange(e.target.value);
                                                            },
                                                            onKeyDown: function(e) {
                                                                if (e.key === "Escape") {
                                                                    e.target.blur();
                                                                }
                                                                if (e.key === "Enter") {
                                                                    e.preventDefault();
                                                                    var actualUrl = inputValue;
                                                                    if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                                                        actualUrl = "http://".concat(actualUrl);
                                                                    }
                                                                    if (isValidUrl(actualUrl)) {
                                                                        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                                            url: actualUrl
                                                                        }));
                                                                    } else {
                                                                        onChange(product);
                                                                    }
                                                                }
                                                            },
                                                            placeholder: "Paste a link to this product",
                                                            name: "url"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            css: {
                                                                marginTop: 15,
                                                                display: "flex"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    css: {
                                                                        width: "100%",
                                                                        marginRight: 15
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                        flex: 1,
                                                                        width: "100%",
                                                                        theme: "primary",
                                                                        color: palette/* greenSuccess */.CU,
                                                                        textColor: palette/* white */.ix,
                                                                        type: "button",
                                                                        onClick: function() {
                                                                            var actualUrl = inputValue;
                                                                            if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                                                                actualUrl = "http://".concat(actualUrl);
                                                                            }
                                                                            if (isValidUrl(actualUrl)) {
                                                                                onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                                                    url: actualUrl
                                                                                }));
                                                                            } else {
                                                                                onChange(product);
                                                                            }
                                                                        },
                                                                        children: "Add Product"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                    flex: 1,
                                                                    width: "100%",
                                                                    theme: "secondary",
                                                                    color: palette/* greenSuccess */.CU,
                                                                    onClick: function() {
                                                                        toggle();
                                                                    },
                                                                    type: "button",
                                                                    children: "Cancel"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: 25,
                                            minWidth: 515
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: {
                                                    marginBottom: 15
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                    css: {
                                                        margin: 0,
                                                        fontSize: 16,
                                                        color: palette/* text */.fL
                                                    },
                                                    children: "Add this product to the Govlaunch platform!"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelayedMount, {
                                                delay: 5,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                                    autoFocus: true,
                                                    leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Link, {}),
                                                    value: inputValue || "",
                                                    onChange: function(e) {
                                                        return onInputChange(e.target.value);
                                                    },
                                                    onKeyDown: function(e) {
                                                        if (e.key === "Escape") {
                                                            e.target.blur();
                                                        }
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            var actualUrl = inputValue;
                                                            if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                                                actualUrl = "http://".concat(actualUrl);
                                                            }
                                                            if (isValidUrl(actualUrl)) {
                                                                onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                                    url: actualUrl
                                                                }));
                                                            } else {
                                                                onChange(product);
                                                            }
                                                        }
                                                    },
                                                    placeholder: "Paste a link to this product",
                                                    name: "url"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    marginTop: 15,
                                                    display: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            width: "100%",
                                                            marginRight: 15
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                            theme: "primary",
                                                            color: palette/* greenSuccess */.CU,
                                                            textColor: "#fff",
                                                            type: "button",
                                                            onClick: function() {
                                                                var actualUrl = inputValue;
                                                                if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                                                    actualUrl = "http://".concat(actualUrl);
                                                                }
                                                                if (isValidUrl(actualUrl)) {
                                                                    onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                                        url: actualUrl
                                                                    }));
                                                                } else {
                                                                    onChange(product);
                                                                }
                                                            },
                                                            children: "Add Product"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                        color: palette/* greenSuccess */.CU,
                                                        theme: "secondary",
                                                        success: true,
                                                        onClick: toggle,
                                                        type: "button",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            });
                        },
                        children: function(param) {
                            var innerRef = param.innerRef;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag, {
                                onClose: onClose,
                                css: {
                                    maxWidth: 255,
                                    height: 48,
                                    paddingLeft: 15,
                                    paddingRight: 15
                                },
                                selected: selected,
                                highlighted: Boolean(isOpen),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            marginRight: 10,
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                            name: product.name,
                                            image: product.logo,
                                            size: 25
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                                        css: {
                                            color: palette/* text */.fL,
                                            fontWeight: 500,
                                            fontSize: 12,
                                            textTransform: "uppercase"
                                        },
                                        children: product.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RawButton, {
                                        type: "button",
                                        onClick: toggle,
                                        tabIndex: 0,
                                        css: {
                                            cursor: "pointer",
                                            outline: 0
                                        },
                                        "aria-label": "Toggle product popover",
                                        innerRef: innerRef,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Alert, {})
                                    }),
                                    onClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RawButton, {
                                        tabIndex: 0,
                                        type: "button",
                                        onClick: onClose,
                                        "aria-label": "Remove product",
                                        css: {
                                            marginLeft: 10
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagClose, {})
                                    })
                                ]
                            });
                        }
                    });
                }
            });
        }
    });
};
NewProductTag.propTypes = {
    product: (prop_types_default()).object.isRequired,
    onClose: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    selected: (prop_types_default()).bool
};
NewProductTag.defaultProps = {
    onClose: (noop_default()),
    onChange: (noop_default()),
    selected: false
};
function isValidUrl(url) {
    return es/* string */.Z_().url().isValidSync(url);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/ProductTag.js











function ProductTag(_param) {
    var product = _param.product, onClose = _param.onClose, selected = _param.selected, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "onClose",
        "selected"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            maxWidth: 255,
            height: 48,
            paddingLeft: 15,
            paddingRight: 15
        },
        selected: selected
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginRight: 10,
                    display: "inline-flex"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    name: product.name,
                    image: product.logo,
                    size: 25
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                css: {
                    color: palette/* text */.fL,
                    fontWeight: 500,
                    fontSize: 12,
                    textTransform: "uppercase"
                },
                children: product.name
            }),
            onClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RawButton, {
                tabIndex: 0,
                type: "button",
                onClick: onClose,
                css: {
                    marginLeft: 10
                },
                "aria-label": "Remove product",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagClose, {})
            })
        ]
    }));
};
ProductTag.propTypes = {
    product: (prop_types_default()).object.isRequired,
    onClose: (prop_types_default()).func,
    selected: (prop_types_default()).bool
};
ProductTag.defaultProps = {
    onClose: (noop_default()),
    selected: false
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/StoryProductSelect.js




























var StoryProductSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(StoryProductSelect, Component);
    var _super = (0,_create_super/* default */.Z)(StoryProductSelect);
    function StoryProductSelect() {
        (0,_class_call_check/* default */.Z)(this, StoryProductSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyDown", function(e) {
            var _props = _this.props, products = _props.products, onChange = _props.onChange, inputValue = _props.inputValue;
            if (e.key === "Backspace" && inputValue.length === 0 && products.length > 0) {
                onChange(dropRight_default()(1, products));
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleRemoveProduct", function(e, product) {
            e.persist();
            var _props = _this.props, products = _props.products, onChange = _props.onChange;
            onChange(products.filter(function(maybeProduct) {
                return maybeProduct !== product;
            }));
            _this.inputRef.focus();
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClearKeyDown", function(e) {
            e.preventDefault();
            if (e.key === "Enter") {
                var onChange = _this.props.onChange;
                onChange([]);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(newValue) {
            var _props = _this.props, products = _props.products, onInputValueChange = _props.onInputValueChange, onChange = _props.onChange;
            onChange(products.concat(newValue));
            onInputValueChange("");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(StoryProductSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, defaultValue = _props.defaultValue, products = _props.products, placeholder = _props.placeholder, foundProducts = _props.selectableProducts, onChange = _props.onChange, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, itemToString = _props.itemToString, disabled = _props.disabled, onFocus = _props.onFocus, onBlur = _props.onBlur, error = _props.error, autoFocus = _props.autoFocus, viewerCanSuggestProducts = _props.viewerCanSuggestProducts, props = (0,_object_without_properties/* default */.Z)(_props, [
                    "defaultValue",
                    "products",
                    "placeholder",
                    "selectableProducts",
                    "onChange",
                    "inputValue",
                    "onInputValueChange",
                    "itemToString",
                    "disabled",
                    "onFocus",
                    "onBlur",
                    "error",
                    "autoFocus",
                    "viewerCanSuggestProducts"
                ]);
                var validationState = error ? "error" : undefined;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    itemToString: itemToString,
                    defaultSelectedItem: defaultValue,
                    inputValue: inputValue,
                    onChange: this.handleChange,
                    selectedItem: products,
                    selectedItemChanged: function(a, b) {
                        if (a && b) {
                            return a.length !== b.length;
                        }
                        return a !== b;
                    },
                    stateReducer: defaultStateReducer,
                    children: function(param) {
                        var getInputProps = param.getInputProps, getRootProps = param.getRootProps, getItemProps = param.getItemProps, selectedItems = param.selectedItem, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, inputValue = param.inputValue;
                        var selectableProducts = foundProducts.filter(function(param) {
                            var _id = param._id;
                            return !selectedItems.find(function(param) {
                                var productId = param._id;
                                return productId === _id;
                            });
                        });
                        var isMenuOpen = isOpen && selectableProducts.length > 0 || isOpen && inputValue;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({
                            refKey: "innerRef"
                        }), props), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SharedRef, {
                                    children: function(param) {
                                        var current = param.current, innerRef = param.innerRef;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tags, {
                                            innerRef: function(node) {
                                                _this.tagsRef = node;
                                            },
                                            isOpen: isMenuOpen || validationState === "error",
                                            validationState: validationState,
                                            disabled: disabled,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsPack, {
                                                    validationState: validationState,
                                                    children: [
                                                        selectedItems.map(function(product) {
                                                            return product._id || product.url ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductTag, {
                                                                product: product,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveProduct(e, product);
                                                                },
                                                                selected: true,
                                                                disabled: disabled
                                                            }, product._id || product.id) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewProductTag, {
                                                                product: product,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveProduct(e, product);
                                                                },
                                                                onChange: function(updatedProduct) {
                                                                    onChange(products.map(function(maybeProduct) {
                                                                        return maybeProduct === product ? updatedProduct : maybeProduct;
                                                                    }));
                                                                    current().focus();
                                                                },
                                                                selected: true,
                                                                disabled: disabled
                                                            }, product._id || product.id);
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsAutosizeInput, (0,_object_spread/* default */.Z)({
                                                            tabIndex: 0,
                                                            disabled: disabled,
                                                            inputRef: function(node) {
                                                                innerRef(node);
                                                                _this.inputRef = node;
                                                            },
                                                            value: inputValue,
                                                            onFocus: onFocus,
                                                            onBlur: onBlur,
                                                            autoFocus: autoFocus
                                                        }, getInputProps({
                                                            placeholder: selectedItems.length === 0 ? placeholder : null,
                                                            "aria-label": placeholder,
                                                            onKeyDown: _this.handleKeyDown,
                                                            onChange: function(e) {
                                                                onInputValueChange(e.target.value);
                                                            }
                                                        })))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                                    onKeyDown: function(e) {
                                                        _this.handleClearKeyDown(e);
                                                        current().focus();
                                                    },
                                                    onClick: function() {
                                                        onChange([]);
                                                        current().focus();
                                                    }
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (isMenuOpen || validationState === "error") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsMenu, {
                                    validationState: validationState,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsPack, {
                                            validationState: validationState,
                                            children: [
                                                selectableProducts.map(function(product, index) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                        index: index,
                                                        item: product,
                                                        active: index === highlightedIndex
                                                    })), {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                                                            children: product.name
                                                        })
                                                    }), product._id);
                                                }),
                                                inputValue.length > 0 && viewerCanSuggestProducts && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                    index: selectableProducts.length,
                                                    item: {
                                                        id: "@".concat(Math.random().toString(36)),
                                                        name: inputValue
                                                    },
                                                    active: highlightedIndex === selectableProducts.length
                                                })), {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagText, {
                                                        children: [
                                                            'Add "',
                                                            inputValue,
                                                            '"'
                                                        ]
                                                    })
                                                }), inputValue)
                                            ]
                                        }),
                                        error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: error
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                });
            }
        }
    ]);
    return StoryProductSelect;
}(react.Component);
(0,_define_property/* default */.Z)(StoryProductSelect, "propTypes", {
    defaultValue: (prop_types_default()).array,
    products: (prop_types_default()).array.isRequired,
    placeholder: (prop_types_default()).string,
    selectableProducts: (prop_types_default()).array.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    inputValue: (prop_types_default()).string.isRequired,
    onInputValueChange: (prop_types_default()).func.isRequired,
    itemToString: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    error: (prop_types_default()).string,
    autoFocus: (prop_types_default()).bool,
    viewerCanSuggestProducts: (prop_types_default()).bool
});
(0,_define_property/* default */.Z)(StoryProductSelect, "defaultProps", {
    defaultValue: [],
    itemToString: get_default()("_id"),
    disabled: false,
    onFocus: (noop_default()),
    onBlur: (noop_default()),
    error: null,
    autoFocus: true,
    viewerCanSuggestProducts: true,
    placeholder: "Type product names..."
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/MultiProductSelect.js





























var MultiProductSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(MultiProductSelect, Component);
    var _super = (0,_create_super/* default */.Z)(MultiProductSelect);
    function MultiProductSelect() {
        (0,_class_call_check/* default */.Z)(this, MultiProductSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleKeyDown", function(e) {
            var _props = _this.props, products = _props.products, onChange = _props.onChange, inputValue = _props.inputValue;
            if (e.key === "Backspace" && inputValue.length === 0 && products.length > 0) {
                onChange(dropRight_default()(1, products));
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleRemoveProduct", function(e, product) {
            e.persist();
            var _props = _this.props, products = _props.products, onChange = _props.onChange;
            onChange(products.filter(function(maybeProduct) {
                return maybeProduct !== product;
            }));
            var focusables = Array.from(_this.tagsRef.querySelectorAll('[tabindex="0"]:not([aria-label="Toggle product popover"])'));
            var position = focusables.findIndex(function(focusable) {
                return focusable === e.target;
            });
            var element = focusables[position > 0 ? position - 1 : 1];
            if (products.length > 1 && element) {
                element.focus();
            } else if (products.length === 1 && element) {
                _this.inputRef.focus();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClearKeyDown", function(e) {
            e.preventDefault();
            if (e.key === "Enter") {
                var onChange = _this.props.onChange;
                onChange([]);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(newValue) {
            var _props = _this.props, products = _props.products, onChange = _props.onChange, onInputValueChange = _props.onInputValueChange;
            onChange(products.concat(newValue));
            onInputValueChange("");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(MultiProductSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, placeholder = _props.placeholder, defaultValue = _props.defaultValue, products = _props.products, foundProducts = _props.selectableProducts, onChange = _props.onChange, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, itemToString = _props.itemToString, disabled = _props.disabled, onFocus = _props.onFocus, onBlur = _props.onBlur, error = _props.error, props = (0,_object_without_properties/* default */.Z)(_props, [
                    "placeholder",
                    "defaultValue",
                    "products",
                    "selectableProducts",
                    "onChange",
                    "inputValue",
                    "onInputValueChange",
                    "itemToString",
                    "disabled",
                    "onFocus",
                    "onBlur",
                    "error"
                ]);
                var validationState = error ? "error" : undefined;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    itemToString: itemToString,
                    defaultSelectedItem: defaultValue,
                    inputValue: inputValue,
                    onChange: this.handleChange,
                    selectedItem: products,
                    selectedItemChanged: function(a, b) {
                        if (a && b) {
                            return a.length !== b.length;
                        }
                        return a !== b;
                    },
                    stateReducer: defaultStateReducer,
                    children: function(param) {
                        var getInputProps = param.getInputProps, getRootProps = param.getRootProps, getItemProps = param.getItemProps, selectedItems = param.selectedItem, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, inputValue = param.inputValue;
                        var selectableProducts = foundProducts.filter(function(param) {
                            var _id = param._id;
                            return !selectedItems.find(function(param) {
                                var productId = param._id;
                                return productId === _id;
                            });
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({
                            refKey: "innerRef"
                        }), props), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SharedRef, {
                                    children: function(param) {
                                        var current = param.current, innerRef = param.innerRef;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tags, {
                                            innerRef: function(node) {
                                                _this.tagsRef = node;
                                            },
                                            isOpen: isOpen || validationState === "error",
                                            validationState: validationState,
                                            disabled: disabled,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsPack, {
                                                    validationState: validationState,
                                                    children: [
                                                        uniqBy_default()(function(product) {
                                                            return product._id || product.id || product.objectID;
                                                        }, selectedItems).map(function(product) {
                                                            return product._id || product.url ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductTag, {
                                                                product: product,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveProduct(e, product);
                                                                },
                                                                selected: true,
                                                                disabled: disabled
                                                            }, product._id || product.id) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewProductTag, {
                                                                product: product,
                                                                onClose: function(e) {
                                                                    return _this.handleRemoveProduct(e, product);
                                                                },
                                                                onChange: function(updatedProduct) {
                                                                    onChange(products.map(function(maybeProduct) {
                                                                        return maybeProduct === product ? updatedProduct : maybeProduct;
                                                                    }));
                                                                    current().focus();
                                                                },
                                                                selected: true,
                                                                disabled: disabled
                                                            }, product._id || product.id);
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsAutosizeInput, (0,_object_spread/* default */.Z)({
                                                            tabIndex: 0,
                                                            disabled: disabled,
                                                            inputRef: function(node) {
                                                                innerRef(node);
                                                                _this.inputRef = node;
                                                            },
                                                            value: inputValue
                                                        }, getInputProps({
                                                            placeholder: selectedItems.length === 0 ? placeholder : null,
                                                            "aria-label": placeholder,
                                                            onKeyDown: _this.handleKeyDown,
                                                            onBlur: onBlur,
                                                            onFocus: onFocus,
                                                            onChange: function(event) {
                                                                onInputValueChange(event.target.value);
                                                            }
                                                        })))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                                    onKeyDown: function(e) {
                                                        _this.handleClearKeyDown(e);
                                                        current().focus();
                                                    },
                                                    onClick: function() {
                                                        onChange([]);
                                                        current().focus();
                                                    }
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (isOpen || validationState === "error") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsMenu, {
                                    validationState: validationState,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsPack, {
                                            validationState: validationState,
                                            children: selectableProducts.map(function(product, index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                    index: index,
                                                    item: product,
                                                    active: index === highlightedIndex
                                                })), {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagText, {
                                                        children: product.name
                                                    })
                                                }), product._id);
                                            })
                                        }),
                                        error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: error
                                        }),
                                        selectableProducts.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsMenuHint, {
                                            children: "No products found"
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                });
            }
        }
    ]);
    return MultiProductSelect;
}(react.Component);
(0,_define_property/* default */.Z)(MultiProductSelect, "propTypes", {
    defaultValue: (prop_types_default()).array,
    products: (prop_types_default()).array.isRequired,
    placeholder: (prop_types_default()).string,
    selectableProducts: (prop_types_default()).array.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    inputValue: (prop_types_default()).string.isRequired,
    onInputValueChange: (prop_types_default()).func.isRequired,
    itemToString: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    error: (prop_types_default()).string
});
(0,_define_property/* default */.Z)(MultiProductSelect, "defaultProps", {
    defaultValue: [],
    itemToString: get_default()("_id"),
    disabled: false,
    onFocus: (noop_default()),
    onBlur: (noop_default()),
    error: null,
    placeholder: "Type product names..."
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/icons/Claimed.js




var Claimed = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "Shape"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z",
                fill: "#FFF",
                fillRule: "nonzero"
            })
        ]
    }));
};
/* harmony default export */ var icons_Claimed = (Claimed);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/measure/translatePropsIntoFontSize.js
/**
 * @param  {Object} props
 * @return {Object}
 */ function translatePropsIntoFontSize(props) {
    switch(props.size){
        case "large":
        case "small":
        default:
            return {
                fontSize: 14,
                fontWeight: 500,
                letterSpacing: 0.5,
                lineHeight: 1.14
            };
        case "xsmall":
            return {
                fontSize: 12,
                fontWeight: 500,
                letterSpacing: 0.4,
                lineHeight: 1.33
            };
    }
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/options/GovernmentOption.js










function GovernmentOption(_param) {
    var name = _param.name, seal = _param.seal, ownerless = _param.ownerless, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "seal",
        "ownerless"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: (0,_object_spread/* default */.Z)({}, GovernmentOption_containerStyle, translatePropsIntoFontSize(props), GovernmentOption_applyActiveStyles(props)),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                name: name,
                image: seal,
                size: 25
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: nameStyle,
                children: name
            }),
            ownerless === false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Claimed, {})
        ]
    }));
};
GovernmentOption.propTypes = {
    name: (prop_types_default()).string.isRequired,
    seal: (prop_types_default()).string,
    ownerless: (prop_types_default()).bool
};
GovernmentOption.defaultProps = {
    seal: null,
    ownerless: false
};
/**
 * @param  {Boolean} active
 * @return {?Object}
 */ function GovernmentOption_applyActiveStyles(param) {
    var active = param.active;
    if (active) {
        return {
            color: palette/* primary */.T$,
            fontWeight: 500
        };
    }
    return null;
}
var nameStyle = {
    marginLeft: 15,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: 400
};
var GovernmentOption_containerStyle = {
    position: "relative",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    border: "none",
    height: "auto",
    textAlign: "left",
    borderTop: "none",
    color: palette/* text */.fL,
    textTransform: "none",
    boxShadow: "none",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    whiteSpace: "normal",
    wordWrap: "normal"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/elements/Menu.js







function Menu(_param) {
    var validationState = _param.validationState, children = _param.children, css = _param.css, props = (0,_object_without_properties/* default */.Z)(_param, [
        "validationState",
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            css: (0,_object_spread/* default */.Z)({
                position: "absolute",
                overflowY: "auto",
                overflowX: "hidden",
                backgroundColor: "#fff",
                width: "100%",
                border: "solid 1px ".concat(validationState === "error" ? palette/* red */.Q6 : palette/* darkSkyBlue */.Gf),
                display: "flex",
                flexDirection: "column",
                zIndex: 1030,
                marginTop: -3,
                borderBottomRightRadius: 4,
                borderBottomLeftRadius: 4,
                overflow: "hidden",
                height: "auto",
                boxSizing: "border-box"
            }, css)
        }, props), {
            children: children
        }))
    });
};
Menu.propTypes = {
    children: (prop_types_default()).any.isRequired,
    style: (prop_types_default()).object,
    validationState: prop_types_default().oneOf([
        "error"
    ]),
    css: (prop_types_default()).object
};
Menu.defaultProps = {
    style: null,
    validationState: null,
    css: {}
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/options/OptionsWrapper.js






function OptionsWrapper(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            "> :first-of-type": {
                paddingTop: 20
            },
            "> :last-of-type": {
                paddingBottom: 20
            }
        }
    }, props), {
        children: children
    }));
};
OptionsWrapper.propTypes = {
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/measure/translatePropsIntoHeight.js
/**
 * @param  {Object} props
 * @return {Number}
 */ function translatePropsIntoHeight(props) {
    switch(props.size){
        case "large":
            return 48;
        case "small":
        default:
            return 42;
        case "xsmall":
            return 30;
    }
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/typeahead/TypeaheadInput.js







function TypeaheadInput(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,_object_spread/* default */.Z)({
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            borderRadius: 4,
            boxSizing: "border-box",
            backgroundColor: "#ffffff",
            border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
            cursor: "pointer",
            lineHeight: 1.14,
            height: translatePropsIntoHeight(props),
            zIndex: 1001
        }, disabledStyles(props), openStyles(props), validationStateStyles(props)),
        children: children
    });
};
TypeaheadInput.propTypes = {
    children: (prop_types_default()).any.isRequired
};
function disabledStyles(param) {
    var disabled = param.disabled;
    if (disabled) {
        return {
            pointerEvents: "none",
            backgroundColor: palette/* lightestGray */.v2,
            border: "solid 1px transparent",
            cursor: "default"
        };
    }
}
function openStyles(param) {
    var isOpen = param.isOpen;
    if (isOpen) {
        return {
            border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
            borderBottom: "solid 1px transparent",
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        };
    }
}
function validationStateStyles(param) {
    var validationState = param.validationState;
    if (validationState === "error") {
        return {
            borderColor: palette/* red */.Q6
        };
    } else if (validationState === "success") {
        return {
            borderColor: palette/* greenSuccess */.CU
        };
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/typeahead/TypeaheadTextInput.js






function TypeaheadTextInput(_param) {
    var inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread/* default */.Z)({
        spellCheck: false,
        autoComplete: "off",
        css: TypeaheadTextInput_inputStyle,
        style: overrideStyle,
        ref: inputRef
    }, props));
};
TypeaheadTextInput.propTypes = {
    inputRef: (prop_types_default()).any
};
TypeaheadTextInput.defaultProps = {
    inputRef: function() {}
};
var TypeaheadTextInput_inputStyle = {
    boxSizing: "border-box",
    flex: "1 1 auto",
    width: "100%",
    height: "100%",
    letterSpacing: 0.5,
    lineHeight: 1.14,
    fontWeight: 500,
    fontSize: 14,
    "::placeholder": {
        color: palette/* sealBlue */.N9
    },
    outline: 0,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "transparent",
    border: "1px solid transparent"
};
var overrideStyle = {
    boxShadow: "none"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/GovernmentSelect.js





















var GovernmentSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(GovernmentSelect, Component);
    var _super = (0,_create_super/* default */.Z)(GovernmentSelect);
    function GovernmentSelect() {
        (0,_class_call_check/* default */.Z)(this, GovernmentSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClear", function() {
            var onChange = _this.props.onChange;
            onChange(null);
            // we need to wait for the state to change so the component is mounted again
            // and the ref is available
            setTimeout(function() {
                return _this.inputRef.focus();
            }, 1);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(government) {
            var onChange = _this.props.onChange;
            onChange(government);
            setTimeout(function() {
                return _this.containerRef.focus();
            }, 1);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(GovernmentSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, governments = _props.governments, disabled = _props.disabled, value = _props.value, validationState = _props.validationState, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, onFocus = _props.onFocus, onBlur = _props.onBlur, placeholder = _props.placeholder, size = _props.size;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    selectedItem: value,
                    onChange: this.handleChange,
                    inputValue: inputValue,
                    onInputValueChange: onInputValueChange,
                    itemToString: function(government) {
                        return government ? buildGovernmentName(government) : null;
                    },
                    children: function(param) {
                        var isOpen = param.isOpen, getItemProps = param.getItemProps, getInputProps = param.getInputProps, highlightedIndex = param.highlightedIndex, inputValue = param.inputValue, onInputValueChange = param.onInputValueChange;
                        var isMenuOpened = isOpen && governments.length > 0;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypeaheadInput, {
                                    isOpen: isMenuOpened,
                                    disabled: disabled,
                                    validationState: validationState,
                                    placeholder: placeholder,
                                    size: size,
                                    onFocus: onFocus,
                                    onBlur: onBlur,
                                    children: [
                                        value ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                                            type: "button",
                                            css: valueStyle,
                                            ref: function(node) {
                                                _this.containerRef = node;
                                            },
                                            onClick: _this.handleClear,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                    name: buildGovernmentName(value),
                                                    image: value.logo,
                                                    size: 25
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    style: GovernmentSelect_nameStyle,
                                                    children: buildGovernmentName(value)
                                                }),
                                                value.ownerless === false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Claimed, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeaheadTextInput, (0,_object_spread/* default */.Z)({
                                            inputRef: function(node) {
                                                _this.inputRef = node;
                                            },
                                            placeholder: placeholder,
                                            value: inputValue,
                                            onChange: function(e) {
                                                return onInputValueChange(e.target.value);
                                            }
                                        }, getInputProps())),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                            onClick: _this.handleClear
                                        })
                                    ]
                                }),
                                isMenuOpened && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
                                    css: {
                                        marginTop: 0
                                    },
                                    validationState: validationState,
                                    children: governments.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsWrapper, {
                                        children: governments.map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentOption, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                item: item,
                                                active: index === highlightedIndex
                                            })), {
                                                name: buildGovernmentName(item),
                                                seal: item.logo,
                                                ownerless: item.ownerless
                                            }), item._id);
                                        })
                                    })
                                })
                            ]
                        });
                    }
                });
            }
        }
    ]);
    return GovernmentSelect;
}(react.Component);
(0,_define_property/* default */.Z)(GovernmentSelect, "propTypes", {
    onChange: (prop_types_default()).func.isRequired,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    value: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    validationState: (prop_types_default()).string,
    inputValue: (prop_types_default()).string,
    onInputValueChange: (prop_types_default()).func.isRequired,
    governments: prop_types_default().arrayOf((prop_types_default()).object),
    placeholder: (prop_types_default()).string,
    size: prop_types_default().oneOf([
        "xsmall",
        "small",
        "large"
    ])
});
(0,_define_property/* default */.Z)(GovernmentSelect, "defaultProps", {
    onFocus: null,
    onBlur: null,
    value: null,
    inputValue: "",
    validationState: null,
    disabled: false,
    governments: [],
    placeholder: null,
    size: "small"
});

var GovernmentSelect_nameStyle = {
    marginLeft: 15
};
var valueStyle = {
    display: "flex",
    flex: 1,
    alignItems: "center",
    height: "100%",
    paddingLeft: 15,
    letterSpacing: 0.5,
    fontSize: 14,
    fontWeight: 500,
    color: palette/* primary */.T$,
    background: "none",
    border: 0,
    outline: 0
};
/**
 * @param  {Object} government
 * @return {String}
 */ function buildGovernmentName(government) {
    return "".concat(government.city.name, ", ").concat(government.city.state);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsInputContainer.js






/**
 * @param  {Boolean} disabled
 * @return {Object}
 */ function TagsInputContainer_applyDisabledStyles(param) {
    var disabled = param.disabled;
    if (disabled) {
        return {
            backgroundColor: palette/* lightestGray */.v2,
            border: "1px solid transparent"
        };
    }
    return null;
}
/**
 * @param  {Boolean} isOpen
 * @return {Object}
 */ function TagsInputContainer_applyAttentionStyles(param) {
    var isOpen = param.isOpen;
    if (isOpen) {
        return {
            border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        };
    }
    return null;
}
/**
 * @param  {String} validationState
 * @return {Object}
 */ function TagsInputContainer_applyValidationStateStyles(param) {
    var validationState = param.validationState;
    if (validationState === "error") {
        return {
            borderColor: palette/* red */.Q6
        };
    }
    if (validationState === "success") {
        return {
            borderColor: palette/* greenSuccess */.CU
        };
    }
    return null;
}
function TagsInputContainer(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,_object_spread/* default */.Z)({
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            minHeight: 48,
            height: "100%",
            boxSizing: "border-box",
            borderRadius: 4,
            border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
            backgroundColor: "#ffffff",
            paddingRight: 20
        }, TagsInputContainer_applyDisabledStyles(props), TagsInputContainer_applyAttentionStyles(props), TagsInputContainer_applyValidationStateStyles(props)),
        children: children
    });
};
TagsInputContainer.propTypes = {
    children: (prop_types_default()).node.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsWrapper.js









var TagsWrapper = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(TagsWrapper, Component);
    var _super = (0,_create_super/* default */.Z)(TagsWrapper);
    function TagsWrapper() {
        (0,_class_call_check/* default */.Z)(this, TagsWrapper);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TagsWrapper, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread/* default */.Z)({
                    css: {
                        paddingBottom: 5,
                        paddingLeft: 5,
                        paddingRight: 5,
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        flex: "1 1 auto",
                        flexWrap: "wrap"
                    }
                }, this.props));
            }
        }
    ]);
    return TagsWrapper;
}(react.Component);
(0,_define_property/* default */.Z)(TagsWrapper, "contextTypes", {
    disabled: (prop_types_default()).bool
});
(0,_define_property/* default */.Z)(TagsWrapper, "getChildContext", function(param) {
    var disabled = param.disabled;
    return disabled;
});


;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/TagsInput.js















var TagsInput = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(TagsInput, Component);
    var _super = (0,_create_super/* default */.Z)(TagsInput);
    function TagsInput() {
        (0,_class_call_check/* default */.Z)(this, TagsInput);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", {
            inputValue: ""
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(item) {
            var _props = _this.props, selectedItems = _props.value, onChange = _props.onChange;
            onChange((0,_to_consumable_array/* default */.Z)(selectedItems).concat([
                item
            ]));
            _this.input.focus();
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleInputKeyDown", function(e) {
            var _props = _this.props, value = _props.value, onChange = _props.onChange;
            var isCommandOrCtrl = e.metaKey || e.ctrlKey;
            if (isCommandOrCtrl) {
                if (e.key === "Backspace") {
                    _this.setState({
                        inputValue: ""
                    });
                    onChange([], e);
                    return;
                }
            }
            if (e.key === "Backspace" && !e.target.value) {
                var nextValue = (0,_to_consumable_array/* default */.Z)(value);
                nextValue.pop();
                onChange(nextValue, e);
            }
            if ([
                "Enter",
                ",",
                "Tab"
            ].includes(e.key) || e.keyCode === 32) {
                if (!e.target.value) {
                    return;
                }
                _this.setState({
                    inputValue: ""
                });
                onChange((0,_to_consumable_array/* default */.Z)(value).concat([
                    e.target.value
                ]), e);
                e.preventDefault();
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleRemove", function(index) {
            var _props = _this.props, value = _props.value, onChange = _props.onChange;
            onChange(value.filter(function(tag, maybeIndex) {
                return maybeIndex !== index;
            }));
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleInputChange", function(e) {
            var inputValue = e.target.value;
            if (inputValue.includes(",")) {
                var _props = _this.props, value = _props.value, onChange = _props.onChange;
                onChange((0,_to_consumable_array/* default */.Z)(value).concat((0,_to_consumable_array/* default */.Z)(inputValue.split(",").map(function(tag) {
                    return tag.trim();
                }).filter(Boolean))));
                return;
            }
            _this.setState({
                inputValue: inputValue
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleBlur", function(e) {
            var _props = _this.props, onBlur = _props.onBlur, value = _props.value;
            if (onBlur) {
                onBlur(value, e);
                _this.setState({
                    inputValue: ""
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClear", function() {
            _this.props.onChange([]);
            _this.input.focus();
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "inputRef", function(inputRef) {
            _this.input = inputRef;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(TagsInput, [
        {
            /**
   * @return {ReactElement}
   */ key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, placeholder = _props.placeholder, value = _props.value, validationState = _props.validationState;
                var disabled = this.props.disabled;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsInputContainer, {
                    disabled: disabled,
                    css: inputContainerStyle,
                    validationState: validationState,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsWrapper, {
                        children: [
                            value.map(function(tag, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag, {
                                    onClose: function() {
                                        return _this.handleRemove(index);
                                    },
                                    isActive: true,
                                    children: tag
                                }, tag);
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsAutosizeInput, {
                                placeholder: placeholder,
                                value: this.state.inputValue,
                                disabled: disabled,
                                onChange: this.handleInputChange,
                                onKeyDown: this.handleInputKeyDown,
                                onFocus: this.props.onFocus,
                                onBlur: this.handleBlur
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return TagsInput;
}(react.Component);
(0,_define_property/* default */.Z)(TagsInput, "propTypes", {
    placeholder: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).array,
    onChange: (prop_types_default()).func.isRequired,
    onBlur: (prop_types_default()).func,
    onFocus: (prop_types_default()).func,
    validationState: (prop_types_default()).string
});
(0,_define_property/* default */.Z)(TagsInput, "defaultProps", {
    value: [],
    onBlur: function() {},
    validationState: null,
    disabled: false,
    placeholder: null,
    onFocus: (noop_default())
});

var inputContainerStyle = {
    paddingRight: 0
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/EmailTagsInputField.js











var checkIsValidEmail = function(email) {
    return es/* string */.Z_().email().required().isValidSync(email);
};
/**
 * @param  {String} error
 * @param  {Boolean} valid
 * @return {?String}
 */ var getValidationState = function(param) {
    var touched = param.touched, error = param.error, valid = param.valid;
    if (!touched) {
        return null;
    }
    if (error) {
        return "error";
    }
    if (valid) {
        return "success";
    }
    return null;
};
function EmailTagsInputField(_param) {
    var input = _param.input, meta = _param.meta, placeholder = _param.placeholder, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "input",
        "meta",
        "placeholder"
    ]);
    var touched = meta.touched, error = meta.error;
    var hasAnyEmail = Array.isArray(input.value) && input.value.length > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsInput, (0,_object_spread/* default */.Z)({
                value: input.value || [],
                onChange: function(emails, event) {
                    var lastEmail = (0,fp.last)(emails);
                    var isValidEmail = checkIsValidEmail(lastEmail);
                    // It should always forward the change event when removing an email
                    if (event.key === "Backspace") {
                        return input.onChange(emails);
                    }
                    if (!isValidEmail) {
                        return;
                    }
                    input.onChange(emails);
                },
                onFocus: input.onFocus,
                onBlur: function(emails, e) {
                    if (!e.target.value) {
                        input.onBlur(emails);
                        return;
                    }
                    var email = e.target.value;
                    var isValidEmail = checkIsValidEmail(email);
                    if (isValidEmail) {
                        input.onBlur((0,_to_consumable_array/* default */.Z)(emails).concat([
                            email
                        ]));
                    }
                },
                validationState: getValidationState(meta),
                placeholder: !hasAnyEmail ? placeholder : null
            }, rest)),
            touched && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
                children: Array.isArray(error) ? (0,fp.head)(error) : error
            })
        ]
    });
};
EmailTagsInputField.propTypes = {
    input: (prop_types_default()).object.isRequired,
    meta: (prop_types_default()).object.isRequired,
    placeholder: (prop_types_default()).string
};
EmailTagsInputField.defaultProps = {
    placeholder: "Type e-mails..."
};
function Error(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            color: palette/* red */.Q6,
            fontSize: 12,
            fontWeight: 300,
            marginTop: 7
        }
    }, props), {
        children: children
    }));
}
Error.propTypes = {
    children: (prop_types_default()).node.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/options/Option.js








/**
 * @param  {Boolean} active
 * @return {?Object}
 */ function Option_applyActiveStyles(active) {
    if (active) {
        return {
            color: palette/* primary */.T$,
            fontWeight: 400
        };
    }
    return null;
}
function Option(_param) {
    var children = _param.children, active = _param.active, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "active"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            position: "relative",
            cursor: "pointer",
            display: "block",
            border: "none",
            height: "auto",
            textAlign: "left",
            borderTop: "none",
            color: palette/* text */.fL
        }, translatePropsIntoFontSize(props)), {
            fontWeight: 400,
            textTransform: "none",
            boxShadow: "none",
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            wordWrap: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }), Option_applyActiveStyles(active))
    }, props), {
        children: children
    }));
};
Option.propTypes = {
    children: (prop_types_default()).node.isRequired,
    active: (prop_types_default()).bool
};
Option.defaultProps = {
    active: false
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/options/Placeholder.js








/**
 * @param  {Boolean} isOpen
 * @return {?Object}
 */ function applyOpenStyles(param) {
    var isOpen = param.isOpen;
    if (isOpen) {
        return {
            color: palette/* primary */.T$
        };
    }
    return null;
}
function Placeholder(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, translatePropsIntoFontSize(props)), {
            textAlign: "left",
            lineHeight: "100%",
            overflow: "hidden",
            color: palette/* sealBlue */.N9,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block"
        }), applyOpenStyles(props)),
        children: children
    });
};
Placeholder.propTypes = {
    children: (prop_types_default()).any.isRequired
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/elements/SelectInput.js








function SelectInput(_param) {
    var children = _param.children, disabled = _param.disabled, isOpen = _param.isOpen, validationState = _param.validationState, css = _param.css, native = _param.native, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "disabled",
        "isOpen",
        "validationState",
        "css",
        "native"
    ]);
    if (native) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            css: (0,_object_spread/* default */.Z)({
                width: "100%",
                borderRadius: 4,
                boxSizing: "border-box",
                backgroundColor: "#ffffff",
                border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
                cursor: "pointer",
                outline: 0,
                fontSize: 14,
                lineHeight: 1.14,
                height: translatePropsIntoHeight(props),
                paddingLeft: 20,
                paddingRight: 20,
                "&:active, &:focus": {
                    border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf)
                },
                userSelect: "none"
            }, SelectInput_disabledStyles(disabled), SelectInput_validationStateStyles(validationState), css)
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        css: (0,_object_spread/* default */.Z)({
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            borderRadius: 4,
            boxSizing: "border-box",
            backgroundColor: "#ffffff",
            border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
            cursor: "pointer",
            outline: 0,
            lineHeight: 1.14,
            height: translatePropsIntoHeight(props),
            paddingLeft: 20,
            paddingRight: 20,
            "&:active, &:focus": {
                border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf)
            },
            userSelect: "none"
        }, SelectInput_disabledStyles(disabled), SelectInput_openStyles(isOpen), SelectInput_validationStateStyles(validationState), css)
    }, props), {
        children: children
    }));
};
SelectInput.propTypes = {
    children: (prop_types_default()).any.isRequired,
    disabled: (prop_types_default()).bool,
    isOpen: (prop_types_default()).bool,
    validationState: (prop_types_default()).string,
    css: (prop_types_default()).object,
    native: (prop_types_default()).bool
};
SelectInput.defaultProps = {
    disabled: false,
    isOpen: false,
    validationState: null,
    css: {},
    native: false
};
function SelectInput_disabledStyles(disabled) {
    if (disabled) {
        return {
            pointerEvents: "none",
            backgroundColor: palette/* lightestGray */.v2,
            border: "solid 1px transparent",
            cursor: "default"
        };
    }
}
function SelectInput_openStyles(isOpen) {
    if (isOpen) {
        return {
            border: "solid 1px ".concat(palette/* darkSkyBlue */.Gf),
            "&:focus, &:active": {
                borderBottom: "solid 1px transparent"
            },
            borderBottom: "solid 1px transparent",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        };
    }
}
function SelectInput_validationStateStyles(validationState) {
    if (validationState === "error") {
        return {
            borderColor: palette/* red */.Q6
        };
    }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/elements/TopBottomChevron.js





function TopBottomChevron(param) {
    var disabled = param.disabled, large = param.large, small = param.small;
    var size = large || small ? 12 : 10;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: topBottomChevronStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginBottom: 2
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Chevron */.Tt, {
                    size: size,
                    color: disabled ? palette/* darkGray */.O5 : palette/* primary */.T$,
                    direction: "top"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Chevron */.Tt, {
                size: size,
                color: disabled ? palette/* darkGray */.O5 : palette/* primary */.T$,
                direction: "bottom"
            })
        ]
    });
};
TopBottomChevron.propTypes = {
    large: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    disabled: (prop_types_default()).bool
};
TopBottomChevron.defaultProps = {
    disabled: false,
    large: false,
    small: false
};
var topBottomChevronStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: "auto"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/Select.js














function Select(param) {
    var value = param.value, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, placeholder = param.placeholder, validationState = param.validationState, items = param.items, size = param.size, native = param.native;
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var selectedValue = value !== null && typeof value === "object" && value.value === null ? null : value;
    if (native) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectInput, {
            isOpen: isOpen,
            native: true,
            validationState: validationState,
            size: size,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: function() {
                return setOpen(!isOpen);
            },
            onChange: function(event) {
                return onChange(event.currentTarget.value);
            },
            value: selectedValue && typeof selectedValue === "object" ? selectedValue.value : selectedValue || "",
            children: items.map(function(param) {
                var value = param.value, label = param.label;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                    value: value,
                    children: label
                }, "".concat(value, "--").concat(label));
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
        itemToString: get_default()("value"),
        onChange: function(value) {
            return onChange(value);
        },
        selectedItem: selectedValue,
        children: function(param) {
            var selectedItem = param.selectedItem, getToggleButtonProps = param.getToggleButtonProps, getItemProps = param.getItemProps, isOpen = param.isOpen, highlightedIndex = param.highlightedIndex;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isOpen: isOpen
                    }, getToggleButtonProps()), {
                        validationState: validationState,
                        size: size,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        children: [
                            selectedItem ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    fontSize: 14,
                                    letterSpacing: 0.5,
                                    lineHeight: 1.14,
                                    fontWeight: 500,
                                    color: palette/* primary */.T$,
                                    boxSizing: "border-box"
                                },
                                children: selectedItem.label
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Placeholder, {
                                children: placeholder
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBottomChevron, {})
                        ]
                    })),
                    isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
                        css: {
                            marginTop: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsWrapper, {
                            children: items.map(function(item, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                    item: item,
                                    active: highlightedIndex === index
                                })), {
                                    children: item.label
                                }), item.value);
                            })
                        })
                    })
                ]
            });
        }
    });
};
Select.propTypes = {
    value: (prop_types_default()).any,
    onChange: (prop_types_default()).func.isRequired,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    placeholder: (prop_types_default()).string.isRequired,
    validationState: (prop_types_default()).string,
    items: (prop_types_default()).array.isRequired,
    size: (prop_types_default()).string,
    native: (prop_types_default()).bool
};
Select.defaultProps = {
    value: null,
    validationState: null,
    size: null,
    onFocus: null,
    onBlur: null,
    native: false
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/options/CategoryOption.js









function CategoryOption(_param) {
    var name = _param.name, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, omit_default()([
        "active"
    ], props)), {
        css: (0,_object_spread/* default */.Z)({}, CategoryOption_containerStyle, translatePropsIntoFontSize(props), CategoryOption_applyActiveStyles(props)),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: CategoryOption_nameStyle,
            children: name
        })
    }));
};
CategoryOption.propTypes = {
    name: (prop_types_default()).string.isRequired
};
/**
 * @param  {Boolean} active
 * @return {?Object}
 */ function CategoryOption_applyActiveStyles(param) {
    var active = param.active;
    if (active) {
        return {
            color: palette/* primary */.T$,
            fontWeight: 500
        };
    }
    return null;
}
var CategoryOption_nameStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: 400
};
var CategoryOption_containerStyle = {
    position: "relative",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    border: "none",
    height: "auto",
    textAlign: "left",
    borderTop: "none",
    color: palette/* text */.fL,
    textTransform: "none",
    boxShadow: "none",
    paddingLeft: 10,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    whiteSpace: "normal",
    wordWrap: "normal"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/CategorySelect.js





















var CategorySelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CategorySelect, Component);
    var _super = (0,_create_super/* default */.Z)(CategorySelect);
    function CategorySelect() {
        (0,_class_call_check/* default */.Z)(this, CategorySelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "inputRef", /*#__PURE__*/ react.createRef());
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClear", function() {
            var _props = _this.props, onChange = _props.onChange, onInputValueChange = _props.onInputValueChange;
            onChange(null);
            onInputValueChange("");
            // we need to wait for the state to change so the component is mounted again
            // and the ref is available
            setTimeout(function() {
                return _this.inputRef.current.focus();
            }, 1);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(category) {
            var onChange = _this.props.onChange;
            onChange(category);
            setTimeout(function() {
                return _this.containerRef.focus();
            }, 1);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(CategorySelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, categories = _props.categories, disabled = _props.disabled, value = _props.value, validationState = _props.validationState, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, onFocus = _props.onFocus, onBlur = _props.onBlur, placeholder = _props.placeholder, size = _props.size, zIndex = _props.zIndex;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    selectedItem: value,
                    onChange: this.handleChange,
                    inputValue: inputValue,
                    onInputValueChange: onInputValueChange,
                    itemToString: function(category) {
                        return category ? category.name : null;
                    },
                    children: function(param) {
                        var isOpen = param.isOpen, getItemProps = param.getItemProps, getInputProps = param.getInputProps, highlightedIndex = param.highlightedIndex, inputValue = param.inputValue, onInputValueChange = param.onInputValueChange;
                        var isMenuOpened = isOpen && categories.length > 0;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypeaheadInput, {
                                    isOpen: isMenuOpened,
                                    disabled: disabled,
                                    validationState: validationState,
                                    placeholder: placeholder,
                                    size: size,
                                    onFocus: onFocus,
                                    onBlur: onBlur,
                                    children: [
                                        value ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                                            type: "button",
                                            css: CategorySelect_valueStyle,
                                            ref: function(node) {
                                                _this.containerRef = node;
                                            },
                                            onClick: _this.handleClear,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    children: value.name
                                                }),
                                                value.ownerless === false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Claimed, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeaheadTextInput, (0,_object_spread/* default */.Z)({
                                            inputRef: _this.inputRef,
                                            placeholder: placeholder,
                                            value: inputValue,
                                            onChange: function(e) {
                                                return onInputValueChange(e.target.value);
                                            }
                                        }, getInputProps())),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                            onClick: _this.handleClear,
                                            style: {
                                                marginTop: 0
                                            }
                                        })
                                    ]
                                }),
                                isMenuOpened && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
                                    css: {
                                        marginTop: 0,
                                        zIndex: zIndex
                                    },
                                    validationState: validationState,
                                    children: categories.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsWrapper, {
                                        children: categories.map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryOption, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                item: item,
                                                active: index === highlightedIndex
                                            })), {
                                                name: item.name
                                            }), item._id);
                                        })
                                    })
                                })
                            ]
                        });
                    }
                });
            }
        }
    ]);
    return CategorySelect;
}(react.Component);
(0,_define_property/* default */.Z)(CategorySelect, "propTypes", {
    onChange: (prop_types_default()).func.isRequired,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    value: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    validationState: (prop_types_default()).string,
    inputValue: (prop_types_default()).string,
    onInputValueChange: (prop_types_default()).func.isRequired,
    categories: prop_types_default().arrayOf((prop_types_default()).object),
    placeholder: (prop_types_default()).string,
    zIndex: (prop_types_default()).number,
    size: prop_types_default().oneOf([
        "xsmall",
        "small",
        "large"
    ])
});
(0,_define_property/* default */.Z)(CategorySelect, "defaultProps", {
    onFocus: null,
    onBlur: null,
    value: null,
    inputValue: "",
    validationState: null,
    disabled: false,
    categories: [],
    placeholder: null,
    size: "small",
    zIndex: css_layers/* SELECT */.XD
});

var CategorySelect_valueStyle = {
    display: "flex",
    flex: 1,
    alignItems: "center",
    height: "100%",
    paddingLeft: 15,
    letterSpacing: 0.5,
    fontSize: 14,
    fontWeight: 500,
    color: palette/* primary */.T$,
    background: "none",
    border: 0,
    outline: 0
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/ProductSelect.js






















var ProductSelect = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductSelect, Component);
    var _super = (0,_create_super/* default */.Z)(ProductSelect);
    function ProductSelect() {
        (0,_class_call_check/* default */.Z)(this, ProductSelect);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleClear", function() {
            var onChange = _this.props.onChange;
            onChange(null);
            // we need to wait for the state to change so the component is mounted again
            // and the ref is available
            setTimeout(function() {
                return _this.inputRef.focus();
            }, 1);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleChange", function(product) {
            var onChange = _this.props.onChange;
            onChange(product);
            setTimeout(function() {
                return _this.containerRef.focus();
            }, 1);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ProductSelect, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, products = _props.products, disabled = _props.disabled, value = _props.value, validationState = _props.validationState, inputValue = _props.inputValue, onInputValueChange = _props.onInputValueChange, onFocus = _props.onFocus, onBlur = _props.onBlur, placeholder = _props.placeholder, size = _props.size;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
                    // stateReducer={stateReducer}
                    selectedItem: value,
                    onChange: this.handleChange,
                    inputValue: inputValue,
                    initialInputValue: "",
                    onInputValueChange: function(value) {
                        return onInputValueChange(value || "");
                    },
                    itemToString: function(product) {
                        return product ? product.name : null;
                    },
                    children: function(param) {
                        var isOpen = param.isOpen, openMenu = param.openMenu, getItemProps = param.getItemProps, getInputProps = param.getInputProps, highlightedIndex = param.highlightedIndex, inputValue = param.inputValue, onInputValueChange = param.onInputValueChange;
                        var isMenuOpened = isOpen && products.length > 0;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypeaheadInput, {
                                    isOpen: isMenuOpened,
                                    disabled: disabled,
                                    validationState: validationState,
                                    placeholder: placeholder,
                                    size: size,
                                    children: [
                                        value ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                                            type: "button",
                                            css: ProductSelect_valueStyle,
                                            ref: function(node) {
                                                _this.containerRef = node;
                                            },
                                            onClick: _this.handleClear,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                    name: value.name,
                                                    image: value.logo,
                                                    size: 25
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    style: ProductSelect_nameStyle,
                                                    children: value.name
                                                }),
                                                value.ownerless === false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_Claimed, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypeaheadTextInput, (0,_object_spread/* default */.Z)({
                                            inputRef: function(node) {
                                                _this.inputRef = node;
                                            },
                                            onBlur: onBlur,
                                            onFocus: function(e) {
                                                openMenu();
                                                if (onFocus) {
                                                    onFocus(e);
                                                }
                                            },
                                            placeholder: placeholder,
                                            value: inputValue,
                                            onChange: function(e) {
                                                return onInputValueChange(e.target.value);
                                            }
                                        }, getInputProps())),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Clear, {
                                            onClick: _this.handleClear
                                        })
                                    ]
                                }),
                                isMenuOpened && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
                                    css: {
                                        marginTop: 0
                                    },
                                    validationState: validationState,
                                    children: products.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsWrapper, {
                                        children: products.map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductOption, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                                item: item,
                                                active: index === highlightedIndex
                                            })), {
                                                name: item.name,
                                                logo: item.logo
                                            }), item._id);
                                        })
                                    })
                                })
                            ]
                        });
                    }
                });
            }
        }
    ]);
    return ProductSelect;
}(react.Component);
(0,_define_property/* default */.Z)(ProductSelect, "propTypes", {
    onChange: (prop_types_default()).func.isRequired,
    onFocus: (prop_types_default()).func,
    onBlur: (prop_types_default()).func,
    value: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    validationState: (prop_types_default()).string,
    inputValue: (prop_types_default()).string,
    onInputValueChange: (prop_types_default()).func.isRequired,
    products: prop_types_default().arrayOf((prop_types_default()).object),
    placeholder: (prop_types_default()).string,
    size: prop_types_default().oneOf([
        "xsmall",
        "small",
        "large"
    ])
});
(0,_define_property/* default */.Z)(ProductSelect, "defaultProps", {
    onFocus: null,
    onBlur: null,
    value: null,
    inputValue: "",
    validationState: null,
    disabled: false,
    products: [],
    placeholder: null,
    size: "small"
});

var ProductSelect_nameStyle = {
    marginLeft: 15
};
var ProductSelect_valueStyle = {
    display: "flex",
    flex: 1,
    alignItems: "center",
    height: "100%",
    paddingLeft: 15,
    letterSpacing: 0.5,
    fontSize: 14,
    fontWeight: 500,
    color: palette/* primary */.T$,
    background: "none",
    border: 0,
    outline: 0
};
function ProductOption(_param) {
    var name = _param.name, logo = _param.logo, active = _param.active, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "logo",
        "active"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: (0,_object_spread/* default */.Z)({}, ProductSelect_containerStyle, translatePropsIntoFontSize(props), ProductSelect_applyActiveStyles({
            active: active
        })),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                name: name,
                image: logo,
                size: 25
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginLeft: 15,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontWeight: 400
                },
                children: name
            })
        ]
    }));
}
ProductOption.propTypes = {
    name: (prop_types_default()).string.isRequired,
    logo: (prop_types_default()).string,
    active: (prop_types_default()).bool
};
ProductOption.defaultProps = {
    logo: null,
    active: false
};
/**
 * @param  {Boolean} active
 * @return {?Object}
 */ function ProductSelect_applyActiveStyles(param) {
    var active = param.active;
    if (active) {
        return {
            color: palette/* primary */.T$,
            fontWeight: 500
        };
    }
    return null;
}
var ProductSelect_containerStyle = {
    position: "relative",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    border: "none",
    height: "auto",
    textAlign: "left",
    borderTop: "none",
    color: palette/* text */.fL,
    textTransform: "none",
    boxShadow: "none",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    whiteSpace: "normal",
    wordWrap: "normal"
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/index.js












/***/ }),

/***/ 24519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(59496);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(40507);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.Z = AutosizeInput;

/***/ }),

/***/ 63402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCounter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useUpdate.js

var updateReducer = function (num) { return (num + 1) % 1000000; };
function useUpdate() {
    var _a = (0,react.useReducer)(updateReducer, 0), update = _a[1];
    return update;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/misc/hookState.js
function resolveHookState(nextState, currentState) {
    if (typeof nextState === 'function') {
        return nextState.length ? nextState(currentState) : nextState();
    }
    return nextState;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useGetSet.js



function useGetSet(initialState) {
    var state = (0,react.useRef)(resolveHookState(initialState));
    var update = useUpdate();
    return (0,react.useMemo)(function () { return [
        function () { return state.current; },
        function (newState) {
            state.current = resolveHookState(newState, state.current);
            update();
        },
    ]; }, []);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useCounter.js



function useCounter(initialValue, max, min) {
    if (initialValue === void 0) { initialValue = 0; }
    if (max === void 0) { max = null; }
    if (min === void 0) { min = null; }
    var init = resolveHookState(initialValue);
    typeof init !== 'number' &&
        console.error('initialValue has to be a number, got ' + typeof initialValue);
    if (typeof min === 'number') {
        init = Math.max(init, min);
    }
    else if (min !== null) {
        console.error('min has to be a number, got ' + typeof min);
    }
    if (typeof max === 'number') {
        init = Math.min(init, max);
    }
    else if (max !== null) {
        console.error('max has to be a number, got ' + typeof max);
    }
    var _a = useGetSet(init), get = _a[0], setInternal = _a[1];
    return [
        get(),
        (0,react.useMemo)(function () {
            var set = function (newState) {
                var prevState = get();
                var rState = resolveHookState(newState, prevState);
                if (prevState !== rState) {
                    if (typeof min === 'number') {
                        rState = Math.max(rState, min);
                    }
                    if (typeof max === 'number') {
                        rState = Math.min(rState, max);
                    }
                    prevState !== rState && setInternal(rState);
                }
            };
            return {
                get: get,
                set: set,
                inc: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num + rDelta; });
                },
                dec: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num - rDelta; });
                },
                reset: function (value) {
                    if (value === void 0) { value = init; }
                    var rValue = resolveHookState(value, get());
                    if (typeof rValue !== 'number') {
                        console.error('value has to be a number or function returning a number, got ' + typeof rValue);
                    }
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    init = rValue;
                    set(rValue);
                },
            };
        }, [init, min, max]),
    ];
}


/***/ })

}]);